/**
 * Number of cascades to use for directional light shadows.
 */
export enum ShadowCascadesMode {
  /** No cascades */
  NoCascades = 1,
  /** Two cascades */
  TwoCascades = 2,
  /** Four cascades */
  FourCascades = 4
}
